/* eslint-disable no-unused-vars */
export enum LocalRole {
  Admin = "ADMIN",
  Manager = "MANAGER",
  Customer = "CUSTOMER",
  Cashier = "CASHIER",
}
